import React from 'react';
import CadastroUsuario from './CadastroUsuario';
import { cadastrarUsuario, criarUsuarioDistribuidor } from '../services/api';
import { portalDistribuidor } from '../utils/portalModo';
import { useNavigate } from 'react-router-dom';

const NovoUsuario = ({ token }) => {
  const navigate = useNavigate();
  const distribuidor = portalDistribuidor();
  const handleCreateSubmit = async (data, token) => {
    try {
      if (distribuidor) await criarUsuarioDistribuidor(data, token);
      else await cadastrarUsuario(data, token);
      navigate('/usuarios');
    } catch (error) {
      console.error('Erro ao cadastrar usuário:', error);
    }
  };

  return (
    <CadastroUsuario 
      token={token} 
      onSubmit={handleCreateSubmit} 
      isEdit={false}
      audiencia={distribuidor ? "distribuidor" : "revenda"}
    />
  );
};

export default NovoUsuario;
